import { connect } from 'react-redux';
import {
  setConfirmationEmail,
  onSend,
} from '../actions';

const mapDispatchToProps = dispatch => ({
  setConfirmationEmail: (e, email) => {
    dispatch(setConfirmationEmail(email));
  },
  onSend: (email) => {
    dispatch(onSend(email));
  },
});

function mapStateToProps({ emailConfirmationInputs }) {
  return { emailConfirmationInputs };
}

export default ComposedCmp => (connect(mapStateToProps, mapDispatchToProps)(ComposedCmp));



// WEBPACK FOOTER //
// ./src/containers/withEmailConfirmationInputs.jsx